import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=32748db4&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=ts&setup=true"
export * from "./Overview.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Overview.vue?vue&type=style&index=0&id=32748db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32748db4",
  null
  
)

export default component.exports